/* <radar-tiers>: si passa sopra una fascia e il prezzo al pezzo di quella
   fascia esce grande sotto.

   Col mouse basta passarci sopra. Ma un telefono il sopra non ce l'ha:
   toccare e' l'unico modo, e un tocco fissa la fascia finche' non se ne
   tocca un'altra. Quindi le due cose convivono - il sopra mostra, il tocco
   ferma - e quando il mouse se ne va torna quella ferma.

   Chi gira con la tastiera vede la stessa cosa arrivando col tabulatore.

   L'evidenza della fascia sotto il mouse la fa il CSS con :hover. Qui non si
   tocca aria-pressed passandoci sopra: quello dice quale fascia e' scelta, e
   chi ascolta la pagina non deve sentirsi cambiare la scelta sotto il
   cursore di qualcun altro.

   I prezzi sono gia' scritti nella pagina, uno per fascia, calcolati da
   Liquid con lo stesso conto dell'app: qui non si fa aritmetica, si copia un
   attributo. Senza questo file le fasce restano leggibili e il prezzo pieno
   e' quello giusto - e' il motivo per cui la prima nasce gia' premuta. */
(function (global) {
  'use strict';

  if (typeof HTMLElement !== 'function') return;

  var RadarTiers = class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;

      this.bands = Array.prototype.slice.call(this.querySelectorAll('.radar-tiers__band'));
      this.price = this.querySelector('[data-radar-tier-price]');
      this.save = this.querySelector('[data-radar-tier-save]');
      if (!this.bands.length || !this.price) return;

      this.ferma = this.bands.filter(function (b) {
        return b.getAttribute('aria-pressed') === 'true';
      })[0] || this.bands[0];

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('mouseover', this.onOver.bind(this));
      this.addEventListener('focusin', this.onOver.bind(this));
      this.addEventListener('mouseleave', this.torna.bind(this));
      this.addEventListener('focusout', this.onOut.bind(this));
    }

    fascia(target) {
      var band = target && target.closest ? target.closest('.radar-tiers__band') : null;
      return band && this.bands.indexOf(band) !== -1 ? band : null;
    }

    // Passarci sopra mostra, e basta: la scelta non cambia.
    onOver(event) {
      var band = this.fascia(event.target);
      if (band) this.mostra(band);
    }

    // Toccare ferma la fascia: sul telefono e' l'unico modo che c'e'.
    onClick(event) {
      var band = this.fascia(event.target);
      if (!band) return;
      this.ferma = band;
      for (var i = 0; i < this.bands.length; i++) {
        this.bands[i].setAttribute('aria-pressed', String(this.bands[i] === band));
      }
      this.mostra(band);
    }

    // Uscendo col tabulatore dall'ultima fascia si torna a quella ferma, ma
    // non passando da una fascia all'altra.
    onOut(event) {
      if (event.relatedTarget && this.contains(event.relatedTarget)) return;
      this.torna();
    }

    torna() {
      if (this.ferma) this.mostra(this.ferma);
    }

    mostra(band) {
      this.price.textContent = band.dataset.price || '';

      // La riga del risparmio esiste solo dove c'e' un risparmio: sulla
      // prima fascia dire "risparmi 0" e' peggio che non dire niente.
      if (!this.save) return;
      var quanto = band.dataset.save || '';
      this.save.textContent = quanto;
      if (quanto) this.save.removeAttribute('hidden');
      else this.save.setAttribute('hidden', '');
    }
  };

  if (!customElements.get('radar-tiers')) customElements.define('radar-tiers', RadarTiers);
})(typeof window !== 'undefined' ? window : globalThis);
